module.exports = __webpack_public_path__ + "static/media/GRD.6489e33e.svg";